





























































































































import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Mutation, State} from 'vuex-class'
import {MutationTypes} from '@/modules/reservation/store/mutations'
import DepartmentType from '@/modules/reservation/model/DepartmenType'
import {Colors, notify} from '@/modules/core/notification'
import ServiceSelect from '@/modules/reservation/components/ServiceSelect.vue'
import ProductListDialog from '@/modules/product/components/ProductListDialog.vue'

@Component({
    components: {ProductListDialog, ServiceSelect},
})
export default class DepartmentTypeDetail extends Vue {
    public $refs: Vue['$refs'] & {
        form: {
            validate: () => boolean,
            update: (field: string, value: any) => void,
        },
    }

    @State(state => state.reservation.currentDepartmentType)
    public type: DepartmentType
    /**
     * Indica la visibilidad del componente
     */
    @State(state => state.reservation.departmentTypeDetail)
    public show: boolean

    @Mutation(`reservation/${MutationTypes.ToggleDepartmentTypeDetail}`)
    public toggleDetail: (show: boolean) => void

    public saving = false
    public productSelect = false
    public productName = ''
    public loadingProduct = true

    public get consecutiveReservations(): boolean {
        return this.type.consecutiveReservations
    }

    public set consecutiveReservations(value: boolean) {
        this.$refs.form.update('consecutiveReservations', value)
    }

    /**
     * Reglas de validación para los campos del tipo de departamento
     */
    public get rules() {
        return {
            name: [
                (v: string) => !!v || 'El nombre del tipo de departamento no puede estar vacío',
            ],
            openingTime: [
                (v: string) => !!v || 'La hora de apertura es obligatoria',
            ],
            closingTime: [
                (value: string) => {
                    if (!value) {
                        return 'La fecha de cierre es obligatoria'
                    }

                    if (!this.type.openingTime) {
                        return 'No se puede declarar fecha de cierre sin fecha de apertura'
                    }

                    return true
                },
            ],
            duration: [(v: string) => !!v || 'El tiempo de reserva es obligatorio'],
        }
    }

    public convertTimeFormatToTimespan(time: string): number {
        const [hours, minutes] = time.split(':')

        return (parseInt(hours, 10) * 60 * 60) + (parseInt(minutes, 10) * 60)
    }

    public get duration() {
        return moment().startOf('day').add(this.type.duration, 'seconds').format('HH:mm')
    }

    public get closingTime() {
        return this.type.closesNextDay
            ? `${this.type.closingTime} del día siguiente`
            : this.type.closingTime
    }

    /**
     * Guarda los cambios del tipo de departamento actualmente en edición
     */
    public async save() {
        if (!this.$refs.form.validate()) {
            return
        }

        this.saving = true

        try {
            await this.$store.dispatch('reservation/saveDepartmentType')
        } catch (e) {
            notify(e.message, Colors.Error)
            this.saving = false

            return
        }

        notify(`${this.type.name} se ha guardado correctamente`)
        this.saving = false
    }
}
